import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsLumbarInstabilityCPR extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_LumbarInstabilityCPR' name='Lumbar Instability CPR' visible={false} flagged={this.props.flagged}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Lumbar Instability CPR'/>);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLINSAGELT40) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLINSSLRGT91 === 'positive') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLINSABERRANTMOTION === 'positive') {
        flagCount++;
    }


    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'LumbarInstabilityCPR'),
        flagged: flagCount === 3 ? true : false
    };
}

const connectedSpecTestsLumbarInstabilityCPR = connect(mapStateToProps)(SpecTestsLumbarInstabilityCPR);
export { connectedSpecTestsLumbarInstabilityCPR as SpecTestsLumbarInstabilityCPR };
